import { fromNullable } from 'fp-ts/lib/Option';

import { dispatch } from 'sdi/shape/functions';
import { Feature, FeatureCollection } from 'sdi/source';

// id -> feature lookup backing the feature detail panel, fed by both the map
// and the table pipelines. Only ever grows: a superset is harmless, a gap is not.

export const emptyCollection = (): FeatureCollection => ({
    type: 'FeatureCollection',
    features: [],
});

// insert is O(n), consider using another data structure
export const cacheFeatures = (uri: string, features: Feature[]) =>
    dispatch('data/layers', layers => {
        const layer = fromNullable(layers[uri]).getOrElseL(emptyCollection);
        features.forEach(feature => {
            const index = layer.features.findIndex(f => f.id === feature.id);
            if (index < 0) {
                layer.features.push(feature);
            } else {
                layer.features[index] = feature;
            }
        });
        return { ...layers, [uri]: layer };
    });
